import Ajax from '../../../../common/js/Ajax.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

export default class LogoutWidget extends Widget {

	constructor($widget) {
		super($widget);
		Ajax.rpc('/logout', () => {
			MessageUtils.ok($widget, 'Du wurdest erfolgreich ausgeloggt.\n[Erneut einloggen|/]');
		}, error => {
			MessageUtils.error($widget, 'Ausloggen fehlgeschlagen', error);
		});
	}

	static updateNavigation() {
		Ajax.rpc('/isLoggedIn', loggedIn => {
			$('.js_logout-nav').toggleClass('hidden', !loggedIn);
		});
	}

}
